import { Box } from '@mui/material';
import React from 'react';
import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import BaseButton from 'components/button/BaseButton';
import { heroSectionStyles } from '../heroSectionStyles';
import { getRedirectUrlWithParams } from '../../../../../../../utils/utils';

export default function HeroHeaderSection() {
	return (
		<Box
			id="hero-header-section"
			sx={[reusableStyles.flexColWithGap(32), reusableStyles.flexCenter, { marginX: '24px' }]}
		>
			<Box id="hero-header-section" sx={[reusableStyles.flexCol, reusableStyles.flexCenter]}>
				<BaseTypography variant="h1_zodiak" styles={[heroSectionStyles.headingTypography]}>
					Make Videos That Sell — Faster.
				</BaseTypography>
				{/* <BaseTypography variant="h1_zodiak" styles={[heroSectionStyles.headingTypography]}> */}
				{/*	Talk, Pose, and Sell for you */}
				{/* </BaseTypography> */}
			</Box>
			<BaseButton
				id="create-now-btn"
				styles={{ ...heroSectionStyles.createButton }}
				href={getRedirectUrlWithParams('https://app.affogato.ai/')}
				target="_blank"
				rel="noopener noreferrer"
			>
				<BaseTypography variant="t2_bold" styles={{ color: 'colors.dark6', textAlign: 'center' }}>
					Create now
				</BaseTypography>
			</BaseButton>
		</Box>
	);
}
